import template from './view-cart-headings.html';
import controller from './view-cart-headings.controller';

let viewCartHeadingsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default viewCartHeadingsComponent;



// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-headings/view-cart-headings.component.js